/**
 * In-memory refresh token; mirrored in sessionStorage via AuthContext persistence.
 */
let refreshToken: string | null = null

export const refreshTokenStore = {
  get: (): string | null => {
    const t = refreshToken
    return t && t.length > 0 ? t : null
  },
  set: (token: string): void => {
    refreshToken = token.length > 0 ? token : null
  },
  clear: (): void => {
    refreshToken = null
  },
}
